// extracted by mini-css-extract-plugin
module.exports = {"modal":"BBUnassignmentModal_modal__2T6zu","close":"BBUnassignmentModal_close__34Jt1","buttons":"BBUnassignmentModal_buttons__3T33l","button":"BBUnassignmentModal_button__byjqU"};